import { FiLogOut } from 'react-icons/fi';
import { useEffect } from 'react';

const LogoutComponent = () => {
  useEffect(() => {
    localStorage.clear();
    window.location.reload();
  }, []);

  return null;
};

const Module = {
  menuItem: {
    to: 'logout',
    title: 'Logout',
    icon: FiLogOut,
    id: 930
  },
  
  routes: [
    {
      path: 'logout',
      element: (
          <LogoutComponent />
      ),
    },
  ],
};

export default Module;
